import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Axios from "axios";
import { Formik, Form } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Button } from "react-bootstrap";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export default function CrudSimpleForm({ 
    updateId,
    validationSchema,
    service,

    children,

    onComplete = () => {}, 
    onReturn = () => {},
    returnUrl = () => {},

    beforeSubmit = () => {},
    value = null,
}) {
    const [data, setData] = useState(validationSchema.default());
    const [loading, setLoading] = useState(false);
    const [submiting, setSubmiting] = useState(false);
    const [messages, setMessages] = useState([]);
    const [complete, setComplete] = useState(false);

    const alert = useAlert();

    const loadDataById = useCallback(async function(id) {
        setLoading(true);
        try {
            const res = await service.findById(id);
            const { data, error, messages } = res;
            
            messages.forEach((msg) =>
                msg.code > 2999 ? alert.error(msg.description) :
                msg.code > 1999 ? alert.show(msg.description, {type: 'warning'}) :
                msg.code >  999 ? alert.show(msg.description) :
                alert.success(msg.description) 
            );

            if(!error) {
                setData(data);
            }
        } catch(err) {
            alert.error(err.message) 
            console.trace(err);
        } finally {
            setLoading(false);
        }
    }, [alert, service]);

    useEffect(() => {
        if(updateId) loadDataById(updateId);
    }, [loadDataById, updateId]);

    useEffect(() => {
        if(value) setData(value);
    }, [value])
    

    async function submit(formData) {
        try {
            setSubmiting(true);
            beforeSubmit(formData);
            let res = null;
            if(updateId) res = await service.update(formData);
            else res = await service.save(formData);
            
            const { error, messages } = res;
            messages.forEach((msg) =>
                msg.code > 2999 ? alert.error(msg.description) :
                msg.code > 1999 ? alert.show(msg.description, {type: 'warning'}) :
                msg.code >  999 ? alert.show(msg.description) :
                alert.success(msg.description) 
            );

            if(!error) {
                onComplete(formData);
                setComplete(true);
                onReturn();
            }
            
        } catch(err) {
            alert.error(err.message) 
            console.trace(err);
        } finally {
            setSubmiting(false);
        }
    }

    if(complete) {
        return <Redirect to={returnUrl} />
    }

    if(loading) {
        return (
            <div>
                <FontAwesomeIcon icon="cog" spin/> Carregando...
            </div>
        )
    }

    return (
        <Formik 
            initialValues={data} enableReinitialize
            validationSchema={validationSchema}
            onSubmit={submit}
            >
            {props => (
                <Form noValidate onSubmit={props.handleSubmit} className="w-100">
                    {children({ ...props, isUpdating: !!updateId })}
                    <div className="d-flex w-100 justify-content-center my-2">
                        <Button variant="secondary" className="mr-4" onClick={() => setComplete(true)} disabled={submiting}>
                            <FontAwesomeIcon icon="reply" /> Voltar
                        </Button>
                        <Button variant="primary" type="submit" disabled={submiting}>
                            <FontAwesomeIcon icon={submiting ? "cog" : "save"}
                                spin={submiting}
                            /> {
                                submiting ? "Salvando..." :
                                updateId ? "Alterar" :
                                "Salvar"
                            }
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}